import * as React from 'react';
import { DesktopNavigation } from '.';
import MobileNavigation from './MobileNavigation';

const Navigation = () => {
  return (
    <div className="fixed w-full top-0 left-0 z-100">
      <MobileNavigation />
      <DesktopNavigation />
    </div>
  );
};

export default Navigation;
